angular.module('eCareVault.common.passwordCollector', []);
